import styled from 'styled-components/native';

export const AvatarRow = styled.View`
  flex-direction: row;
`;

export const AvatarWrapper = styled.View<{ orderNo?: number }>`
  margin-left: ${({ orderNo }) => (orderNo === 0 ? 0 : -10)}px;
`;
